<template>
  <div>
    <b-card v-if="!loading_users && getJornadaId != 0 && isAsistencias">
      <!-- <h2 class="mt-3 m-2">Seccion usuarios</h2> -->
      <div class="option-container">
        <div>
          <input
            class="input-radio"
            type="radio"
            id="1"
            value="1"
            v-model="selected"
          />
          <label for="1" class="input-radio-l">Todos</label>
        </div>
        <div>
          <input
            class="input-radio"
            type="radio"
            id="2"
            value="2"
            v-model="selected"
          />
          <label for="2" class="input-radio-l">Ingresos</label>
        </div>
        <div>
          <input
            class="input-radio"
            type="radio"
            id="3"
            value="3"
            v-model="selected"
          />
          <label for="3" class="input-radio-l">Faltantes</label>
        </div>
      </div>
      <div class="users">
        <b-row v-for="(user, item) in usersS" :key="item">
          <b-col
            cols="3"
            class="text-center"
            v-if="user != undefined"
            :class="
              user.isAs
                ? 'text-success mt-2 border-bottom'
                : 'text-danger border-bottom mt-2'
            "
          >
            {{ user.id }}
          </b-col>
          <b-col
            cols="6"
            class="text-center"
            v-if="user != undefined"
            :class="
              user.isAs
                ? 'text-success mt-2 border-bottom'
                : 'text-danger border-bottom mt-2'
            "
          >
            {{ user.nombre_full }}
          </b-col>
          <b-col
            cols="3"
            class="text-center"
            v-if="user != undefined"
            :class="
              user.isAs
                ? 'text-success mt-2 border-bottom'
                : 'text-danger border-bottom mt-2'
            "
          >
            {{ user.taxi_id_user }}
          </b-col>
        </b-row>
        <!-- <infinite-loading v-if="(selected !== '2')" @infinite="infiniteHandler"></infinite-loading> -->
      </div>
    </b-card>
    <b-card v-if="!isAsistencias">
      <h4 class="text-center">Cargando asistencias..</h4>
    </b-card>
  </div>
</template>
<script>
//import BusEvent from "../../../busEvent";

//import ApiService from "../../../core/services/api.service"; //Getting
const opc = { a: "1", b: "2", c: "3" };
//import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from "vuex";

export default {
  name: "UsersP",

  components: {
    //InfiniteLoading
  },

  data() {
    return {
      users: [],
      asistencias: [],
      selected: opc.a,
      data: [],
      lastReference: 0
    };
  },

  methods: {
    onSelected() {
      switch (this.selected) {
        case opc.a:
          this.users = this.filterAllUsers();
          break;
        case opc.b:
          if (this.networkStateIsOnline) {
            this.users = this.usersOnLine();
          } else {
            this.users = this.filterUsersRegisters();
          }
          break;
        case opc.c:
          if (this.networkStateIsOnline) {
            this.users = this.usersOnlineFaltantes();
          } else {
            this.users = this.filterUsersFaltantes();
          }
          break;
        default:
          break;
      }
    },

    filterAllUsers() {
      //Obtiene todo los usuarios  del STORE - JSON
      //  const tempArray = [];
      const storeUsers = this.getUsers;
      // for (let i = 0; i < 50; i++) {
      //  const user = storeUsers[i];
      //  tempArray.push(user)
      //this.lastReference = i;
      // }
      return storeUsers || [];
    },

    /*  filterUsersRegisters(){ //Obtiene asistencia  Pouchdb por Jornada Y area PREV. SELEC - mode ofline
      const usersReg = this.getAsistencias;
      const users = this.getUsers;
      const filteredIds = [];
      usersReg.forEach(f => {
        if((f.jornada_id == this.getJornadaId) && (f.areaId == this.getAreaId))  filteredIds.push(f.user_id);
      });
      const filtered = users.filter((user) => filteredIds.includes(user.id))
      return filtered || [];
    }, */

    filterUsersFaltantes() {
      // Calcula faltantes en base a usuarios en Pouchdb - mode ofline
      const array = [];
      const usersReg = this.getAsistencias;
      const users = this.getUsers;
      const filteredIds = [];
      usersReg.forEach(f => filteredIds.push(f.usuarioId));
      const filtered = users.filter(user => !filteredIds.includes(user.id));
      for (let i = 0; i < 30; i++) {
        this.lastReference = i;
        array.push(filtered[i]);
      }
      return array || [];
    },

    usersOnLine() {
      // Calcula asistencia - mode online
      const filteredIds = [];
      const users = this.getUsers;
      this.data.forEach(elm => {
        const user = {
          areaId: elm.areaId,
          date: elm.date,
          jornada_id: elm.jornadaId,
          user_id: elm.usuarioId
        };
        if (
          user.jornada_id == this.getJornadaId &&
          user.areaId == this.getAreaId
        )
          filteredIds.push(user.user_id);
      });
      const filtered = users.filter(user => filteredIds.includes(user.id));
      return filtered || [];
    },

    usersOnlineFaltantes() {
      const array = [];
      const filteredIds = [];
      const users = this.getUsers;
      this.data.forEach(elm => {
        filteredIds.push(elm.usuarioId);
      });
      const filtered = users.filter(user => !filteredIds.includes(user.id));
      for (let i = 0; i < 30; i++) {
        array.push(filtered[i]);
        this.lastReference = i;
      }
      return array;
    },
    showAlert() {
      if (this.getJornadaId == 0)
        this.$toasted.show("Debes seleccionar Jornada", {
          duration: 1500,
          type: "error"
        });
    },

    infiniteHandler($state) {
      //Infinit scroll event
      if (this.selected === opc.a) {
        const storeUsers = this.getUsers;
        const lastUser = storeUsers[this.lastReference];
        const _indexLastUser = storeUsers.findIndex(x => x.id === lastUser.id);
        const maxLenght = this.lastReference + 30; //Mostrar usuarios 30 en 30 al scrollear
        if (this.lastReference === storeUsers.lenght) {
          $state.complete();
        } else {
          for (let _index = _indexLastUser + 1; _index <= maxLenght; _index++) {
            const user = storeUsers[_index];
            this.users.push(user);
            this.lastReference = _index;
            $state.loaded();
          }
        }
      }

      if (this.selected === opc.c && !this.networkStateIsOnline) {
        const usersReg = this.getAsistencias;
        const users = this.getUsers;
        const filteredIds = [];
        usersReg.forEach(f => filteredIds.push(f.user_id));
        const filtered = users.filter(user => !filteredIds.includes(user.id));
        const maxLenght = this.lastReference + 30;

        if (this.lastReference === filtered.lenght) {
          $state.complete();
        } else {
          for (
            let _index = this.lastReference + 1;
            _index <= maxLenght;
            _index++
          ) {
            const user = filtered[_index];
            this.users.push(user);
            this.lastReference = _index;
            $state.loaded();
          }
        }
      }

      if (this.selected === opc.c && this.networkStateIsOnline) {
        const filteredIds = [];
        const users = this.getUsers;
        this.data.forEach(elm => {
          filteredIds.push(elm.usuarioId);
        });
        const filtered = users.filter(user => !filteredIds.includes(user.id));
        const maxLenght = this.lastReference + 30;
        if (this.lastReference === filtered.lenght) {
          $state.complete();
        } else {
          for (
            let _index = this.lastReference + 1;
            _index <= maxLenght;
            _index++
          ) {
            const user = filtered[_index];
            this.users.push(user);
            this.lastReference = _index;
            $state.loaded();
          }
        }
      }
    }
  },
  mounted() {
    this.users = this.filterAllUsers();
    // this.getAsistenciasOnline();
    this.showAlert();
  },
  computed: {
    ...mapState({
      loading_users: state => state.users.loading,
      getUsers: state => state.users.users,
      networkStateIsOnline: state => state.network.isOnline,
      getAsistencias: state => state.asistencias.asistencias,
      getJornadaId: state => state.asistencias.jornadaId,
      getAreaId: state => state.asistencias.areaId,
      isAsistencias: state => state.asistencias.isAsistencias
    }),
    usersS() {
      let users = [];
      switch (this.selected) {
        case "1":
          users = this.filterAllUsers();
          break;
        case "2":
          users = this.filterUsersRegisters;
          users.reverse();
          break;
        case "3":
          users = this.filterUsersFaltantes();
          break;
        default:
          users = this.filterAllUsers();
          break;
      }
      const usersReg = this.getAsistencias;
      const self = this;
      users.map(function(x) {
        x.isAs = false;
        usersReg.forEach(f => {
          if (f.jornadaId == self.getJornadaId && x.id === f.usuarioId)
            x.isAs = true;
        });
      });
      // console.log(users.lenght,users);
      if(users.length!==0){
        let last = users.slice(-1);
        if(users[0].id<last[0].id){
          users.reverse();
        }
      }
      return users;
    },
    filterUsersRegisters() {
      //Obtiene asistencia  Pouchdb por Jornada Y area PREV. SELEC - mode ofline
      const usersReg = this.getAsistencias;
      const users = this.getUsers;
      const filteredIds = [];
      usersReg.forEach(f => {
        if (f.jornadaId == this.getJornadaId) filteredIds.push(f.usuarioId);
      });
      const filtered = users.filter(user => filteredIds.includes(user.id));
      return filtered || [];
    }
  },
  destroyed() {}
};
</script>

<style>
.custom-card {
  background-color: #ffffff;
  margin: 5px 5px 8px 5px;
  padding: 5px;
  border-radius: 4px;
  border-color: #444444;
  font-size: 14px;
}

.option-container {
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 10px 5px;
}
.input-radio-l {
  margin: 5px;
  align-self: center;
}

.input-radio {
  margin: 5px;
  padding-top: 8px;
  align-self: center;
  height: 20px;
  width: 20px;
  vertical-align: middle;
}
</style>
